export default "__VITE_ASSET__67977573__"